<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="autoType.id">
                                    {{$t('auto.autoType.type')}} {{$t('auto.autoType.edit')}}</h4>
                                <h4 class="card-title float-left" v-else>
                                    {{$t('auto.autoType.type')}}
                                    {{$t('auto.autoType.add')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-4">

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.typeOfCar")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.typeOfCar"
                                            :class="{invalid : $v.autoType.typeOfCar.$error}">
                                        <option :value="option.key" v-for="option in typeCars" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.typeOfCar.$error">
                                        {{$t("auto.autoType.typeOfCar")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.country")}} <span class="red">*</span></label>
                                    <v-select v-model="autoType.countryDto" label="name"
                                              :options="countryList"
                                              :filterable="false"
                                              @search="onCountrySearch"
                                              @search:focus="onCountryFocus"
                                              :class="{invalid : $v.autoType.countryDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoType && autoType.countryDto && autoType.countryDto.name">
                                            <div v-html="autoType.countryDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoType.countryDto.$error">
                                        {{$t("auto.autoType.country")}} {{$t("messages.combo.empty")}}
                                    </div>
                                </div>

                                <div v-if="autoType.id" class="form-group">
                                    <label>{{$t("auto.autoManufacture.manufacture")}} <span class="red">*</span></label>
                                    <v-select v-model="autoType.autoManufactureDto" label="name"
                                              :options="autoManufactureList"
                                              :filterable="false"
                                              @search="onAutoManufactureSearch"
                                              @search:focus="onAutoManufactureFocus"
                                              :class="{invalid : $v.autoType.autoManufactureDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoType && autoType.autoManufactureDto && autoType.autoManufactureDto.name">
                                            <div v-html="autoType.autoManufactureDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoType.autoManufactureDto.$error">
                                        {{$t("auto.autoManufacture.error")}}
                                    </div>
                                </div>

                                <div v-if="autoType.id" class="form-group">
                                    <label>{{$t("auto.carCategory.category")}} <span class="red">*</span></label>
                                    <v-select v-model="autoType.carCategoryDto" label="name"
                                              :options="carCategoryList"
                                              :filterable="false"
                                              @search="onCarCategorySearch"
                                              @search:focus="onCarCategoryFocus"
                                              :class="{invalid : $v.autoType.carCategoryDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.name"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoType && autoType.carCategoryDto && autoType.carCategoryDto.name">
                                            <div v-html="autoType.carCategoryDto.name"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoType.carCategoryDto.$error">
                                        {{$t("auto.carCategory.error")}}
                                    </div>
                                </div>


                                <div v-if="!autoType.id" class="row">
                                    <div class="col-9">
                                        <div class="form-group">
                                            <label>{{$t("auto.autoManufacture.manufacture")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="autoType.autoManufactureDto" label="name"
                                                      :options="autoManufactureList"
                                                      :filterable="false"
                                                      @search="onAutoManufactureSearch"
                                                      @search:focus="onAutoManufactureFocus"
                                                      :class="{invalid : $v.autoType.autoManufactureDto.$error}">
                                                <template slot="option" slot-scope="option" v-if="option">
                                                    <div v-html="option.name"></div>
                                                </template>
                                                <template slot="selected-option"
                                                          v-if="autoType && autoType.autoManufactureDto && autoType.autoManufactureDto.name">
                                                    <div v-html="autoType.autoManufactureDto.name"
                                                         @click="$eventBus.$emit('search:focus')"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.autoType.autoManufactureDto.$error">
                                                {{$t("auto.autoManufacture.error")}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <label>Бренд Қўшиш</label>
                                        <span class="input-group-button">
                                          <button @click="addAutoManufacture" class="btn btn-info">
                                            <i class="fa fa-plus"></i> Add
                                          </button>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="!autoType.id" class="row">
                                    <div class="col-9">
                                        <div class="form-group">
                                            <label>{{$t("auto.carCategory.category")}} <span
                                                    class="red">*</span></label>
                                            <v-select v-model="autoType.carCategoryDto" label="name"
                                                      :options="carCategoryList"
                                                      :filterable="false"
                                                      @search="onCarCategorySearch"
                                                      @search:focus="onCarCategoryFocus"
                                                      :class="{invalid : $v.autoType.carCategoryDto.$error}">
                                                <template slot="option" slot-scope="option" v-if="option">
                                                    <div v-html="option.name"></div>
                                                </template>
                                                <template slot="selected-option"
                                                          v-if="autoType && autoType.carCategoryDto && autoType.carCategoryDto.name">
                                                    <div v-html="autoType.carCategoryDto.name"
                                                         @click="$eventBus.$emit('search:focus')"></div>
                                                </template>
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                            <div class="red" v-if="$v.autoType.carCategoryDto.$error">
                                                {{$t("auto.carCategory.error")}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <label>Русум Қўшиш</label>
                                        <span class="input-group-button">
                                          <button @click="addCarCategory" class="btn btn-info">
                                            <i class="fa fa-plus"></i> Add
                                          </button>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar != 'Trailers' && autoType.typeOfCar != 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.carPositions")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.carPosition"
                                            :class="{invalid : $v.autoType.carPosition.$error}">
                                        <option :value="option.code" v-for="option in carPositionList"
                                                :key="option.code">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.carPosition.$error">
                                        {{$t("auto.autoType.carPositions")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar != 'Trailers' && autoType.typeOfCar != 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.gearBoxType")}} <span class="red">*</span></label>
                                    <select class="form-control"
                                            v-model="autoType.gearBoxType"
                                            :class="{invalid: $v.autoType.gearBoxType.$error}"
                                    >
                                        <option value="MECHANICS">Механика</option>
                                        <option value="AUTOMATIC">Автомат</option>
                                        <option value="OTHER">Бошқа</option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.gearBoxType.$error">
                                        {{$t("auto.autoType.gearBoxType")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.model")}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="autoType.model"
                                           :class="{invalid : $v.autoType.model.$error}"/>
                                    <div class="red" v-if="$v.autoType.model.$error">
                                        {{$t("auto.autoType.model")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar != 'Trailers' && autoType.typeOfCar != 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.fuelType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.type"
                                            :class="{invalid : $v.autoType.type.$error}">
                                        <option :value="option.key" v-for="option in fuelTypeList" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.type.$error">
                                        {{$t("auto.autoType.fuelType")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar != 'Trailers' && autoType.typeOfCar != 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.horsePower")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.horsePower"
                                           :class="{invalid : $v.autoType.horsePower.$error}"/>
                                    <div class="red" v-if="$v.autoType.horsePower.$error">
                                        {{$t("auto.autoType.horsePower")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="!(autoType.typeOfCar=='Trailers' || autoType.typeOfCar=='HalfTrailers' || autoType.typeOfCar=='Bicycles')">
                                    <label>{{$t("auto.autoType.engineCapacity")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.engineCapacity"
                                           :class="{invalid : $v.autoType.engineCapacity.$error}"/>
                                    <div class="red" v-if="$v.autoType.engineCapacity.$error">
                                        {{$t("auto.autoType.engineCapacity")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.fullWeight")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.fullWeight"
                                           :class="{invalid : $v.autoType.fullWeight.$error}"/>
                                    <div class="red" v-if="$v.autoType.fullWeight.$error">
                                        {{$t("auto.autoType.fullWeight")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="autoType.typeOfCar != 'Truck' &&
                                            autoType.typeOfCar != 'SpecialMachinery' &&
                                            autoType.typeOfCar != 'Trailers' &&
                                            autoType.typeOfCar != 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.seatNumber")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.seatNumber"
                                           :class="{invalid : $v.autoType.seatNumber.$error}"/>
                                    <div class="red" v-if="$v.autoType.seatNumber.$error">
                                        {{$t("auto.autoType.seatNumber")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar == 'Truck' || autoType.typeOfCar == 'Trailers' || autoType.typeOfCar == 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.carryingCapacity")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.carryingCapacity"
                                           :class="{invalid : $v.autoType.carryingCapacity.$error}"/>
                                    <div class="red" v-if="$v.autoType.carryingCapacity.$error">
                                        {{$t("auto.autoType.carryingCapacity")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="autoType.typeOfCar == 'Truck'">
                                    <label>{{$t("auto.autoType.trackTypes")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.trackType"
                                            :class="{invalid : $v.autoType.trackType.$error}">
                                        <option :value="option.code" v-for="option in trackTypeList" :key="option.code">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.trackType.$error">
                                        {{$t("auto.autoType.trackTypes")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="autoType.typeOfCar == 'Truck' || autoType.typeOfCar == 'Trailers' || autoType.typeOfCar == 'HalfTrailers'">
                                    <label>{{$t("auto.autoType.axletree")}}<span
                                            class="red">*</span></label>
                                    <input type="number" class="form-control" v-model="autoType.axletree"
                                           :class="{invalid : $v.autoType.axletree.$error}"/>
                                    <div class="red" v-if="$v.autoType.axletree.$error">
                                        {{$t("auto.autoType.axletree")}}
                                    </div>
                                </div>

                                <div class="form-group" v-if="autoType.typeOfCar == 'SpecialMachinery'">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="autoType.trackedTire">
                                            <span class="form-check-sign"></span>
                                            {{$t("auto.autoType.checkTrackedTire")}}
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="autoType.checkCustomsTax">
                                            <span class="form-check-sign"></span>
                                            {{$t("auto.autoType.checkCustomsTax")}}
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-check pl-0">
                                        <label class="form-check-label" style="padding-left:22px !important">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="autoType.stopProduction">
                                            <span class="form-check-sign"></span>
                                            {{$t("auto.autoType.checkStopProduction")}}
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.rentType")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.rentType"
                                            @change="changeRent"
                                            :class="{invalid : $v.autoType.rentType.$error}">
                                        <option :value="option.name" v-for="option in rentTypeList" :key="option.name">
                                            {{option.typeName}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.rentType.$error">
                                        {{$t("auto.autoType.rentType")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.rentValue")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoType.rentValue"
                                            :class="{invalid : $v.autoType.rentValue.$error}">
                                        <option :value="option.key" v-for="option in rentCoefLookupData"
                                                :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.rentValue.$error">
                                        {{$t("auto.autoType.rentValue")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.autoType.categorization")}} <span class="red">*</span></label>
                                    <select class="form-control"
                                            v-model="autoType.categorization"
                                            :class="{invalid: $v.autoType.categorization.$error}"
                                    >
                                        <option :value="option.key" v-for="option in categorizationList"
                                                :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoType.categorization.$error">
                                        {{$t("auto.autoType.categorization")}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-8" v-if="autoType.id">
                                <div class="row">
                                    <button class="all-btn add-btn float-right" @click="savePrice"
                                            v-if="autoType.id && !autoType.stopProduction">
                                        {{$t("action.savePrice")}}
                                    </button>
                                </div>
                                <div class="row" v-if="!autoType.stopProduction">
                                    <div class="col col-3">
                                        <label>{{$t("auto.autoPrice.price")}}<span
                                                class="red">*</span></label>
                                        <input type="number" class="form-control" v-model="autoPrice.price"/>
                                    </div>

                                    <div class="col col-3">
                                        <label>{{$t("auto.autoPrice.currency")}} <span class="red">*</span></label>
                                        <select class="form-control" v-model="autoPrice.currencyDto.ccode">
                                            <option :value="option.key" v-for="option in currencies"
                                                    :key="option.key">
                                                {{option.name}}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label>{{$t("auto.autoPrice.pricingDate")}} <span
                                                class="red">*</span></label>
                                        <datepicker class="form-control" format="dd/MM/yyyy"
                                                    v-model="autoPrice.pricingDate"
                                                    :clear-button="true"></datepicker>
                                    </div>

                                    <div class="col col-3">
                                        <label>{{$t("auto.autoPrice.source")}}<span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="autoPrice.source"/>
                                    </div>
                                </div>


                                <div class="table-wrapper" v-if="autoType.id">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th>Яратилган сана</th>
                                            <th>Автотранспорт нархи</th>
                                            <th>Валюта</th>
                                            <th>Нарх ўрнатилган сана</th>
                                            <th>Олинган манба</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="autoPrice in autoType.autoPrices" :key="autoPrice.id">
                                            <td>
                                                {{new Date(autoPrice.createDate) | dateFormat('DD/MM/YYYY')}}
                                            </td>
                                            <td>
                                                {{autoPrice.price}}
                                            </td>
                                            <td>
                                                {{autoPrice.currencyDto.ccode}}
                                            </td>
                                            <td>
                                                {{autoPrice.pricingDate}}
                                            </td>
                                            <td>
                                                {{autoPrice.source}}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" >
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AutoManufactureModal/>
        <CarCategoryModal/>
    </div>
</template>

<script>
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Datepicker from 'vuejs-datepicker';
    import {formatDate} from '@/shared/utils';
    import AutoManufactureModal from '@/views/config/auto/auto-manufacture/AutoManufactureModal';
    import CarCategoryModal from '@/views/config/auto/car-category/CarCategoryModal';
    import {clone} from '@/shared/utils';

    export default {
        name: "AutoTypeAddEdit",
        components: {
            Datepicker,
            AutoManufactureModal,
            CarCategoryModal
        },
        data() {
            return {
                processing: false,
                filter: initFilterModel(),
                currencyCode: null,
                autoPrice: {
                    currencyDto: {},
                    price: null,
                    pricingDate: null,
                    source: null
                },
                autoType: {
                    autoManufactureDto: {}
                },
                carCategoryList: [],
                countryList: [],
                autoManufactureList: [],
                typeCars: [],
                carPositionList: [],
                fuelTypeList: [],
                trackTypeList: [],
                rentTypeList: [],
                rentCoefLookupData: [],
                categorizationList: [
                    {key: "1", name: "1.0"},
                    {key: "1.1", name: "1.1"},
                    {key: "1.2", name: "1.2"},
                    {key: "1.3", name: "1.3"}
                ],
                currencies: [
                    {key: "UZS", name: "Сум", nameRu: "Сум"},
                    {key: "RUB", name: "Рубл", nameRu: "Российский рубль"},
                    {key: "USD", name: "Доллар", nameRu: "Доллар США"},
                    {key: "EUR", name: "Евро", nameRu: "Евро"}
                ]
            }
        },
        validations() {
            return {
                autoType: {
                    typeOfCar: {
                        required: required
                    },
                    carCategoryDto: {
                        required: required
                    },
                    countryDto: {
                        required: required
                    },
                    autoManufactureDto: {
                        required: required
                    },
                    carPosition: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar === 'HalfTrailers' ||
                                this.autoType.typeOfCar === 'Trailers';
                        })
                    },
                    gearBoxType: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar === 'HalfTrailers' ||
                                this.autoType.typeOfCar === 'Trailers';
                        })
                    },
                    model: {
                        required: required
                    },
                    type: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar === 'HalfTrailers' ||
                                this.autoType.typeOfCar === 'Trailers';
                        })
                    },
                    horsePower: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar === 'HalfTrailers' ||
                                this.autoType.typeOfCar === 'Trailers';
                        })
                    },
                    engineCapacity: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar === 'Trailers' || this.autoType.typeOfCar === 'HalfTrailers' || this.autoType.typeOfCar === 'Bicycles';
                        })
                    },
                    fullWeight: {
                        required: required
                    },
                    trackType: {
                        required: requiredUnless(() => {
                            return !(this.autoType.typeOfCar === 'Truck')
                        })
                    },
                    seatNumber: {
                        required: requiredUnless(() => {
                            return !(this.autoType.typeOfCar !== 'Truck' &&
                                this.autoType.typeOfCar !== 'SpecialMachinery' &&
                                this.autoType.typeOfCar !== 'Trailers' &&
                                this.autoType.typeOfCar !== 'HalfTrailers')
                        })
                    },
                    rentType: {
                        required: required
                    },
                    categorization: {
                        required: required
                    },
                    carryingCapacity: {
                        required: requiredUnless(() => {
                            return this.autoType.typeOfCar !== 'Truck' ||
                                this.autoType.typeOfCar !== 'Trailers' ||
                                this.autoType.typeOfCar !== 'HalfTrailers';
                        })
                    },
                    rentValue: {
                        required: required
                    },
                    axletree: {
                        required: requiredUnless(() => {
                            return !(this.autoType.typeOfCar === 'Truck' || this.autoType.typeOfCar === 'Trailers' || this.autoType.typeOfCar === 'HalfTrailers')
                        })
                    }
                }
                // autoPrice: {
                //     currencyDto: {
                //         required: requiredUnless(() => {
                //             return !this.autoType.id;
                //         })
                //     },
                //     price: {
                //         required: requiredUnless(() => {
                //             return !this.autoType.id;
                //         })
                //     },
                //     pricingDate: {
                //         required: requiredUnless(() => {
                //             return !this.autoType.id;
                //         })
                //     },
                //     source: {
                //         required: requiredUnless(() => {
                //             return !this.autoType.id;
                //         })
                //     }
                // }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/autoType/' + id)
                        .then(res => {
                            vm.autoType = res.data;
                            vm.changeRent();
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            save() {
                this.$v.$touch();

                console.log("this.$v", this.$v);
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/autoType/save', this.autoType)
                    .then(res => {
                            if (res && res.data && res.data.status === 'SUCCESS') {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.common.saved'),
                                    type: 'success'
                                });
                                this.$router.push('/config/auto');
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: this.autoType.name + '\n' + res.data.message,
                                    type: 'warning'
                                });
                            }

                            this.processing = false;
                        }
                    ).catch(error => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.common.errorOccurred') + '\n' + error.response.data.message,
                        type: 'error'
                    });
                    this.processing = false;
                });

            },

            savePrice() {
                if (!this.autoPrice.price) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: "Автотранспорт нархини киритинг!",
                        type: 'warning'
                    });
                    this.processing = false;
                    return false;
                }

                if (!this.autoPrice.currencyDto || !this.autoPrice.currencyDto.ccode || this.autoPrice.currencyDto.ccode === "") {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: "Валютани танланг!",
                        type: 'warning'
                    });
                    this.processing = false;
                    return false;
                }

                if (!this.autoPrice.pricingDate || this.autoPrice.pricingDate === "") {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: "Нарх ўрнатилган санани киритинг!",
                        type: 'warning'
                    });
                    this.processing = false;
                    return false;
                }

                if (!this.autoPrice.source || this.autoPrice.source === "") {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: "Олинган манбани киритинг!",
                        type: 'warning'
                    });
                    this.processing = false;
                    return false;
                }

                if (this.autoPrice.pricingDate) {
                    this.autoPrice.pricingDate = formatDate(this.autoPrice.pricingDate);
                }
                this.autoPrice.autoTypeDto = this.autoType;
                this.processing = true;
                this.$http.post('/autoType/autoPrice/save', this.autoPrice)
                    .then(res => {
                            if (res.data > 0) {
                                this.$swal({
                                    title: this.$t('messages.common.success'),
                                    text: this.$t('messages.common.saved'),
                                    type: 'success'
                                });
                                window.location.reload();
                            } else {
                                this.$swal({
                                    title: this.$t('messages.common.warning'),
                                    text: res.data.message,
                                    type: 'warning'
                                });
                            }

                            this.processing = false;
                        }
                    ).catch(error => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.common.errorOccurred') + '\n' + error.response.data.message,
                        type: 'error'
                    });
                    this.processing = false;
                });

            },
            cancel() {
                this.$router.push('/config/auto');
            },

            addAutoManufacture() {
                this.$eventBus.$emit('showAutoManufactureModal');
            },

            addCarCategory() {
                this.$eventBus.$emit('showCarCategoryModal');
            },

            getTypeCars() {
                this.$http.get('/type-car').then(response => {
                    this.typeCars = response.data;
                }, err => {
                    console.log(err)
                });
            },

            getCarPosition() {
                this.$http.get('/car-position').then(response => {
                    this.carPositionList = response.data;
                }, err => {
                    console.log(err)
                });
            },

            getAutoFuelType() {
                this.$http.get('/fuel-type-car').then(response => {
                    this.fuelTypeList = response.data;
                }, err => {
                    console.log(err)
                });
            },

            getTrackType() {
                this.$http.get('/track-type').then(response => {
                    this.trackTypeList = response.data;
                }, err => {
                    console.log(err)
                });
            },

            getRentType() {
                this.$http.get('/rent-type').then(response => {
                    this.rentTypeList = response.data;
                }, err => {
                    console.log(err)
                });
            },

            onCarCategorySearch(searchTxt) {
                this.carCategoryList = [];
                this.filter.search = searchTxt;
                this.$http.post('car-category/search', this.filter)
                    .then(res => {
                        this.carCategoryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCarCategoryFocus() {
                this.carCategoryList = [];
                this.filter.search = '';
                this.$http.post('car-category/search', this.filter)
                    .then(res => {
                        this.carCategoryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },

            onCountrySearch(searchTxt) {
                this.countryList = [];
                this.filter.search = searchTxt;
                this.$http.post('country/search', this.filter)
                    .then(res => {
                        this.countryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onCountryFocus() {
                this.countryList = [];
                this.filter.search = '';
                this.$http.post('country/search', this.filter)
                    .then(res => {
                        this.countryList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },

            onAutoManufactureSearch(searchTxt) {
                this.autoManufactureList = [];
                this.filter.search = searchTxt;
                this.$http.post('auto-manufacture/search-manufacture-dto', this.filter)
                    .then(res => {
                        this.autoManufactureList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onAutoManufactureFocus() {
                this.autoManufactureList = [];
                this.filter.search = '';
                this.$http.post('auto-manufacture/search-manufacture-dto', this.filter)
                    .then(res => {
                        this.autoManufactureList = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            changeRent() {
                if (this.autoType.rentType === "LOW") {
                    this.rentCoefLookupData = [{key: "0.05", name: "0.05"}, {key: "0.1", name: "0.1"}];
                } else if (this.autoType.rentType === "MEDIUM") {
                    this.rentCoefLookupData = [{key: "0.1", name: "0.1"}, {key: "0.2", name: "0.2"}, {
                        key: "0.25",
                        name: "0.25"
                    }];
                } else {
                    this.rentCoefLookupData = [{key: "0.25", name: "0.25"}, {key: "0.3", name: "0.3"}, {
                        key: "0.35",
                        name: "0.35"
                    }];
                }
            }

        },

        computed: {},

        created() {
            this.$eventBus.$on('AutoTypeValueByType', (data, type) => {
                if (data && type == 'Manufacture') {
                    this.autoType.autoManufactureDto = clone(data);
                    console.log("this.autoType.autoManufactureDto", this.autoType.autoManufactureDto);
                } else if (data && type == 'Category') {
                    this.autoType.carCategoryDto = clone(data);
                    console.log("this.autoType.carCategoryDto", this.autoType.carCategoryDto);
                }
            });
            this.init();
            this.getTypeCars();
            this.onCountryFocus();
            this.getCarPosition();
            this.getAutoFuelType();
            this.getTrackType();
            this.getRentType();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    .custom td, .custom th {
        border: 1px solid #ddd;
        padding: 4px;
    }

    .custom tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    .custom tr:hover {
        opacity: 1;
        background-color: #dee2e6;
    }

    .custom thead tr th {
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }

    .custom tr {
        font-size: 14px;
    }

</style>